import React from "react";
import { MessageCircle, Zap } from "lucide-react";
import { BRAND } from "../../config/brand";
import { DOWNLOADS_WA_LINK, INSTALL_STEPS } from "./constants";

export const InstallSteps = () => (
  <section className="max-w-[1100px] mx-auto px-6 pb-12">
    <h3 className="text-2xl font-bold text-center mb-6">Como Instalar</h3>
    <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
      {INSTALL_STEPS.map((s) => (
        <div key={s.n} className="rounded-2xl bg-white/5 border border-white/10 p-5">
          <div className="w-9 h-9 rounded-full bg-brand-2 text-white flex items-center justify-center font-extrabold mb-3">
            {s.n}
          </div>
          <p className="font-bold">{s.title}</p>
          <p className="text-xs text-white/60 mt-1">{s.desc}</p>
        </div>
      ))}
    </div>
  </section>
);

export const InstallHelp = () => (
  <section className="max-w-[1100px] mx-auto px-6 pb-20">
    <div className="rounded-2xl border border-[#25D366]/30 bg-gradient-to-br from-[#16210f] to-[#0d160a] p-6 md:p-8 flex flex-col md:flex-row items-center gap-6">
      <div className="w-16 h-16 rounded-2xl bg-[#25D366]/15 flex items-center justify-center border border-[#25D366]/30">
        <Zap className="w-8 h-8 text-[#25D366]" />
      </div>
      <div className="flex-1 text-center md:text-left">
        <h3 className="text-xl font-bold">Precisa de ajuda na instalação?</h3>
        <p className="text-white/70 text-sm mt-1">
          Nossa equipe te orienta passo a passo pelo WhatsApp para deixar tudo funcionando em poucos minutos.
        </p>
      </div>
      <a
        href={DOWNLOADS_WA_LINK}
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-[#25D366] hover:brightness-110 text-white font-bold shadow-lg shadow-[#25D366]/30 transition"
      >
        <MessageCircle className="w-4 h-4" /> Falar no WhatsApp
      </a>
    </div>
  </section>
);

export const DownloadsFooter = () => (
  <footer className="text-center py-6 text-xs text-white/40 border-t border-white/5 space-y-1">
    <p>{BRAND.fullName} © 2026 • Todos os direitos reservados</p>
    <p className="text-brand-light font-semibold" data-testid="downloads-footer-domain">{BRAND.domain}</p>
  </footer>
);
